export class FloorPlace {
  floor: number;
  place: number;

  constructor(floor: number = null, place: number = null) {
    this.floor = floor;
    this.place = place;
  }
}
